export default {
  production: '6465d6b204c24a62270abe68',
  development: '6463a7906855422ba0f676f1',
  test: '6463a7906855422ba0f676f1',
};
